import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const DOT = { high: "#BE123C", medium: "#C59B27", low: "#9E7B1B" };

export function ProfileNudges() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/profile/nudges").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data || !data.nudges || data.nudges.length === 0) return null;

  return (
    <div className="mj-card p-5" data-testid="profile-nudges-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-serif text-lg font-semibold text-[#58111A] flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#C59B27]" /> A few things to complete
        </h2>
        <span className="text-xs text-[#9E7B1B]" data-testid="nudges-completion">{data.completion}% complete</span>
      </div>
      <p className="text-xs text-[#8A6D71] mb-3">Members who complete these get noticeably more genuine interest.</p>
      <div className="space-y-2">
        {data.nudges.slice(0, 4).map((n) => (
          <Link
            key={n.field}
            to={n.cta || "/app/profile/edit"}
            data-testid={`nudge-${n.field}`}
            className="flex items-start gap-3 rounded-xl px-3 py-2.5 bg-[#FAF5EE] hover:bg-[#F5ECDD] transition group"
          >
            <span className="mt-1.5 w-2 h-2 rounded-full shrink-0" style={{ background: DOT[n.priority] || "#C59B27" }} />
            <span className="flex-1 min-w-0">
              <span className="text-sm font-medium text-[#261A1C] block">{n.label}</span>
              <span className="text-xs text-[#605255]">{n.message}</span>
            </span>
            <ArrowRight className="w-4 h-4 text-[#C59B27] mt-1 shrink-0 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        ))}
      </div>
    </div>
  );
}
